import { memo, useCallback } from 'react';
import { Button, IconButton, LeaveArrowRight, ViewEye, World } from '@effizency/efz-design-system';
import { useNavigate } from 'react-router-dom';

// Assets
import { ReactComponent as AvatarIcon } from 'assets/@efz/icons/sidebar/avatar.svg';

import LanguageSelectorDialog from 'components/@efz/Sidebar/Content/UserCard/LanguageSelectorDialog';
// Components
import { StyledSidebarUserCard } from 'components/@efz/Sidebar/StylesSidebar';
import IntlMessages from 'components/util/IntlMessages';

// Constants
import { BASENAME_URL_USER } from 'constants/settings';
import { AVAILABLE_LANGUAGES } from 'constants/user';

import { getUserType } from 'services/user';
// Services
import { getBoolean, isFieldDefined } from 'services/util/auxiliaryUtils';

import { useSidebarStore } from 'stores/sidebar';
// Contexts/Stores
import { useUserStore } from 'stores/user';

const SidebarUserCard = () => {
    const isUADFS = isFieldDefined(localStorage.getItem('uadfs')) ? getBoolean(localStorage.getItem('uadfs')) : false;

    const {
        sidebarOpen,
        languageSelectorDialogOpen,
        actions: { setSidebarOpen, setLanguageSelectorDialogOpen },
    } = useSidebarStore();

    const {
        user,
        actions: { logout, logoutADFS, switchLanguage },
    } = useUserStore();

    const navigate = useNavigate();

    const goToUserPageHandler = () => {
        navigate(BASENAME_URL_USER);
    };

    const clickHandler = () => {
        if (sidebarOpen) goToUserPageHandler();
        else setSidebarOpen(true);
    };

    const logoutHandler = useCallback(() => {
        return isUADFS ? logoutADFS() : logout();
    }, [isUADFS]); //eslint-disable-line

    return (
        <>
            {sidebarOpen ?
                <StyledSidebarUserCard>
                    <div className="title">
                        <div className="info">
                            <AvatarIcon />
                            <div className="text">
                                <span className="name">{user?.name ?? user?.username}</span>
                                <span className="type">{getUserType(user.user_type_id)}</span>
                            </div>
                        </div>
                        <IconButton variant="secondary" size="xs" dataTestId="open-user-data" onClick={clickHandler}>
                            <ViewEye size="xs" variant="secondary" iconBtn />
                        </IconButton>
                    </div>
                    <div className="actions">
                        <Button
                            variant="tertiary"
                            size="sm"
                            startIcon={<World size="xs" variant="secondary" iconBtn />}
                            onClick={() => setLanguageSelectorDialogOpen?.(true)}
                            dataTestId="change-language"
                        >
                            {user.locale.icon}
                        </Button>
                        <Button
                            className="logout"
                            variant="tertiary"
                            size="sm"
                            startIcon={<LeaveArrowRight size="xs" variant="secondary" iconBtn />}
                            onClick={logoutHandler}
                            dataTestId="logout"
                        >
                            <IntlMessages id="label.leave" />
                        </Button>
                    </div>
                </StyledSidebarUserCard>
            :   <AvatarIcon className="avatar-icon clickable" onClick={clickHandler} />}
            {languageSelectorDialogOpen && (
                <LanguageSelectorDialog
                    isOpen={languageSelectorDialogOpen}
                    handleClose={() => setLanguageSelectorDialogOpen?.(false)}
                    languages={AVAILABLE_LANGUAGES}
                    switchLanguage={switchLanguage}
                    currentLocale={user.locale.locale}
                />
            )}
        </>
    );
};

export default memo(SidebarUserCard);
